<template>
    <BaseDialog
        :showDialog="showDialog"
        maxDialogWidth="500"
        headline="lang_GENERIC_CAPTION_ACTION_SHOW_CONNECTIONS"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{$t(showText)}}
                    </v-col>
                </v-row>
                <v-row v-if="csvFileLink !== null"  >
                    <v-col>
                        <a :href="csvFileLink" target="_blank">{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}</a>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog.vue'

export default {
    name:"ShowConnectionsAzPersonsDialog",
    components:{
        BaseDialog
    },
   computed:{
        showDialog: {
            get() { return this.$store.getters.getShowAzPersonsShowConnectionsDialog },
            set(show) { this.$store.commit('setShowAzPersonsShowConnectionsDialog', show) }
        },
        showText:{
            get() { return this.$store.getters.getShowConnectionsDialogText },
            set(text) { this.$store.commit('setShowConnectionsDialogText', text) }
        },
        csvFileLink: { 
            get() { return this.$store.getters.getShowConnectionsCSVLink },
            set(link) { this.$store.commit('setShowConnectionsCSVLink', link)}
        },
   },
   methods:{
       closeDialog() {
            this.showDialog = false
            this.csvFileLink = null
            this.showText= ''

        }
   },
      data() {
        return {
            alvqa: "show-connections-dialog"
        }
    },
}
</script>
